import { Component, Prop, h, Element, State } from '@stencil/core';
import { SiteHeaderSearch } from './pn-marketweb-siteheader-types';
import { state, onChange } from './pn-marketweb-siteheader-search-store';
import { search } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-marketweb-siteheader-search',
  styleUrl: 'pn-marketweb-siteheader-search.scss',
})
export class PnMarketwebSiteheaderSearch {
  @Element() hostElement: Element;

  // Language options
  @Prop() i18n: any;

  // Display option, show only link
  @Prop({ mutable: true }) showOnlyLink: boolean = false;
  // Hide search option
  @Prop({ mutable: true }) hideSearch: boolean = false;
  /** Specifies which language we want to show (sv,da,fi,no,en) */
  @Prop({ mutable: true, reflect: true }) language: string = null;

  /** Specifies the current site id (guid)*/
  @Prop() siteid: string = null;

  // Search data
  @Prop({ mutable: true }) search: SiteHeaderSearch = {};

  // Is this the primary instance?
  @Prop() primary: boolean = false;

  // Only Show icon as search button?
  @Prop() icononly: boolean = true;

  // Autocomplete options
  @State() autoCompleteOptions: string[] = [];

  onSearchValueUpdate() {
    this.getAutocomplete(state.searchValue);
  }

  async getAutocomplete(prefix) {
    if (!this.search.AutocompleteEndpoint || prefix.length < 2) {
      this.autoCompleteOptions = [];
      return;
    }
    if (state.autocompleteSuggestions[prefix]) {
      this.setAutocompleteSuggestions(state.autocompleteSuggestions[prefix]);
      return;
    }

    let autocompleteUrl = `${this.search.AutocompleteEndpoint}?prefix=${prefix}&size=10`;
    if (this.language || this.siteid) {
      autocompleteUrl += `&tags=`;
      if (this.language) {
        autocompleteUrl += `language:${this.language}`;
      }
      if (this.language && this.siteid) {
        autocompleteUrl += `,`;
      }
      if (this.siteid) {
        autocompleteUrl += `siteid:${this.siteid}`;
      }
    }
    const req = await fetch(autocompleteUrl, { signal: state.requestAbortController.signal }).catch(e => {
      console.warn('Unable to fetch autocomplete suggestions', e);
    });
    if (!req) {
      return;
    }
    const data = await req.json();
    if (!data || !data.hits || !data.hits.length) {
      return;
    }
    const suggestions = data.hits
      .filter(item => item.type === 'editorial')
      .map(item => {
        return item.query;
      });

    // Store query in store
    state.autocompleteSuggestions[prefix] = suggestions;
    this.setAutocompleteSuggestions(suggestions);
  }

  setAutocompleteSuggestions(suggestions) {
    if (typeof suggestions !== 'object' || typeof suggestions.length !== 'number' || suggestions.length === 0) {
      return;
    }
    this.autoCompleteOptions = suggestions;
  }
  componentWillLoad() {
    onChange('searchValue', () => {
      this.onSearchValueUpdate();
    });
  }

  componentDidRender() {
    const inputSearchElm = this.hostElement.querySelector('pn-search-field input:not([list])');
    if (inputSearchElm && this.search.AutocompleteEndpoint) {
      inputSearchElm.setAttribute('list', 'siteheader-search-autocomplete');
    }
  }

  render() {
    if (!this.search.formActionUrl || this.hideSearch) {
      return;
    }
    const autocompleteAttribute = this.search.AutocompleteEndpoint ? { list: 'siteheader-search-autocomplete' } : {};
    return (
      <div class="siteheader-search">
        {this.showOnlyLink ? (
          <pn-button href={this.search.formActionUrl} appearance="light" icon={search} tooltip={this.i18n.searchlabel} />
        ) : (
          <form method="get" action={this.search.formActionUrl} role="search">
            <pn-search-field
              {...autocompleteAttribute}
              label={this.i18n.searchlabel}
              name="q"
              button={this.icononly ? 'icon' : null}
              button-label={'Search'}
              placeholder={this.i18n.searchplaceholder}
              onUpdate={(e: CustomEvent) => {
                state.searchValue = e.detail;
              }}
              onSearch={() => {
                const form = this.hostElement.querySelector('form') as HTMLFormElement;
                if (form) {
                  form.submit();
                }
              }}
            />

            {this.primary && this.search.AutocompleteEndpoint ? (
              <datalist id="siteheader-search-autocomplete">
                {this.autoCompleteOptions.map(item => (
                  <option>{item}</option>
                ))}
              </datalist>
            ) : null}
          </form>
        )}
      </div>
    );
  }
}
